module.exports = __webpack_public_path__ + "img/雷丸.8aa067ac.jpg";